import React from "react";
import {Route} from "react-router";
import PrivateRoute from "./app/utils/PrivateRoute";
import VerifyEmail from "./app/utils/auth/VerifyEmail";
import ResetPassword from "./app/utils/auth/ResetPassword";
import ChangePassword from "./app/utils/auth/ChangePassword";
import Stats from "./app/pages/board-game/stats/Stats";
import LoginPage from "./app/utils/auth/LoginPage";
import LogoutPage from "./app/utils/auth/LogoutPage";
import SignupPage from "./app/utils/auth/SignupPage";
import ConfidentialityPolicy from "./app/pages/legal/ConfidentialityPolicy";
import LegalTerms from "./app/pages/legal/LegalTerms";
import LandingPage from "./app/pages/landing/LandingPage";
import {TopBar} from "./app/utils/TopBar/TopBar";
import KillingZeusPage from "./app/pages/killing-zeus/KillingZeusPage";
import UltraMythPage from "./app/pages/ultra-myth/UltraMythPage";
import BoardGamePage from "./app/pages/board-game/BoardGamePage";
import PreviousGameDetails from "./app/pages/board-game/PreviousGamePage";
import TerraformingHome from "./app/pages/board-game/games/terraforming/TerraformingHome";
import MegawattHome from "./app/pages/board-game/games/megawatt/MegawattHome";
import ThroughTheAgesHome from "./app/pages/board-game/games/throughTheAges/ThroughTheAgesHome";
import {AdminPage} from "./app/pages/admin/AdminPage";
import SevenWondersHome from "./app/pages/board-game/games/7wonders/SevenWondersHome";
import BottomBar from "./app/utils/BottomBar/BottomBar";
import HeliopolisHome from "./app/pages/board-game/games/heliopolis/HeliopolisHome";
import {Anniv2025Page} from "./app/pages/anniv2025/Anniv2025";
import PuzzleCGU from "./app/pages/legal/PuzzleCGU";
import PuzzlePage from "./app/pages/anniv2025/components/PuzzlePage";
import {GameGeneratorPage} from "./app/pages/game-generator/GameGenerator";
import {JoinLobbyPage} from "./app/pages/game-generator/JoinLobby";
import GeneratedHome from "./app/pages/board-game/games/generated/GeneratedHome";
import {AdminAnniv2025Page} from "./app/pages/anniv2025/admin/AdminAnniv2025";
import {Anniv2026Page} from "./app/pages/anniv2026/Anniv2026";
import {AdminAnniv2026Page} from "./app/pages/anniv2026/AdminAnniv2026";
import {RevealAnniv2026Page} from "./app/pages/anniv2026/RevealAnniv2026";
import {LeaderboardAnniv2026Page} from "./app/pages/anniv2026/LeaderboardAnniv2026";
import ArkNovaHome from "./app/pages/board-game/games/arknova/ArkNovaHome";
import TestPage from "./app/pages/test/test";

// import Home from "../archive_src/Home";
// import PreviousGameDetails from "../archive_src/PreviousGameDetails";
// import SevenWondersMobile from "../archive_src/SevenWonders/mobile/SevenWondersMobile";
// import TerraformingHome from "../archive_src/terraforming/TerraformingHome";
// import MegawattHome from "../archive_src/megawatt/MegawattHome";
// import ThroughTheAgesHome from "../archive_src/throughTheAges/ThroughTheAgesHome";
// import SevenWondersHome from "../archive_src/7wonders/SevenWondersHome";

const routes = () => (
    <div style={{minHeight: "calc(100vh - 82px)"}}>
            <Route path='/' component={TopBar}/>
            <Route path='/login' component={LoginPage}/>
            <Route path='/logout' component={LogoutPage}/>
            <Route path='/signup' component={SignupPage}/>
            <Route path='/verifyEmail' component={VerifyEmail}/>
            <Route path='/resetPassword' component={ResetPassword}/>
            <Route path='/changePassword' component={ChangePassword}/>
            <Route path='/confidentiality' exact={true} component={ConfidentialityPolicy}/>
            <Route path='/legalterms' exact={true} component={LegalTerms}/>
            <Route path='/legalterms2' exact={true} component={PuzzleCGU}/>
            {/*<PrivateRoute path='/sevenWonders' exact={true} component={SevenWondersMobile}/>*/}
            <Route path='/' exact={true} component={LandingPage}/>
            <Route path='/killing-zeus' exact={true} component={KillingZeusPage}/>
            <Route path='/ultra-myth' exact={true} component={UltraMythPage}/>
            <PrivateRoute path='/board-games' exact={true} component={BoardGamePage} boardGame={true}/>
            <PrivateRoute path='/lobby' exact={true} component={JoinLobbyPage}/>
            <PrivateRoute path='/lobby/:lobbyId' exact={true} component={GameGeneratorPage}/>
            <PrivateRoute path='/board-games/previous-game/:gamekey/:gameId' exact={true} component={PreviousGameDetails} boardGame={true}/>
            <PrivateRoute path='/board-games/terraforming-mars/stats' exact={true} component={Stats} boardGame={true}/>
            <PrivateRoute path='/terraforming/:gameId' exact={true} component={TerraformingHome} boardGame={true}/>
            <PrivateRoute path='/generated/:game/:gameId' exact={true} component={GeneratedHome} boardGame={true}/>
            <PrivateRoute path='/megawatt/:gameId' exact={true} component={MegawattHome} boardGame={true}/>
            <PrivateRoute path='/throughTheAges/:gameId' exact={true} component={ThroughTheAgesHome} boardGame={true}/>
            <PrivateRoute path='/arknova/:gameId' exact={true} component={ArkNovaHome} boardGame={true}/>
            <PrivateRoute path='/sevenWonders/:gameId' exact={true} component={SevenWondersHome} boardGame={true}/>
            <PrivateRoute path='/heliopolis/:gameId' exact={true} component={HeliopolisHome} boardGame={true}/>
            <PrivateRoute path='/anniv2025/admin' exact={true} component={AdminAnniv2025Page}/>
            <Route path='/tuTUlu/enigMES' exact={true} component={Anniv2025Page} admin={true}/>
            <Route path='/tuTUlu/puzzle' exact={true} component={PuzzlePage} admin={true}/>
            <Route path='/anniv/2026' exact={true} component={Anniv2026Page}/>
            <Route path='/anniv/2026/admin' exact={true} component={AdminAnniv2026Page}/>
            <Route path='/anniv/2026/reveal' exact={true} component={RevealAnniv2026Page}/>
            <Route path='/anniv/2026/leaderboard' exact={true} component={LeaderboardAnniv2026Page}/>
            <PrivateRoute path='/admin' exact={true} component={AdminPage} admin={true}/>
            <Route path='/test' exact={true} component={TestPage}/>
            <Route path='/' component={BottomBar}/>
    </div>
);

export default routes;
